/**
 * GIF and sticker picker and settings.
 */
export const gif = {
    pickerTitle: 'GIFs & Stickers',
    searchPlaceholder: 'Search KLIPY',
    tabGifs: 'GIFs',
    tabStickers: 'Stickers',
    noResults: 'No results for "{{query}}"',
    stickersSearchPrompt:
      'Type at least two characters in the search box to find stickers.',
    trendingGifsEmpty: 'No trending GIFs right now. Try searching above.',
    loading: 'Loading…',
    error: 'Failed to load results. Please try again.',
    retryButton: 'Retry',
    rateLimited: "You're searching a bit too fast. Try again in {{seconds}}s.",
    poweredBy: 'Powered by KLIPY',
    fallbackLabel: 'GIF: {{term}}',
    showThisGif: 'Show this GIF',
    removePreview: 'Remove GIF',
    settingsTitle: 'GIFs & Stickers',
    settingsDescription: "Controls whether GIF and sticker content from external providers loads in your browser. When disabled, you'll see a placeholder with the search term instead.",
    privacyAll: 'Show all GIFs and stickers',
    privacyPrivateOnly: 'Only in private conversations',
    privacyFriendsOnly: 'Only from friends',
    privacyDisabled: 'Disable GIFs and stickers entirely',
    conversationDisabledByAdmin: 'Disable GIFs for this conversation',
    conversationDisabledByAdminHint: 'This disables GIF and sticker content for all members',
    contentFilterTitle: 'GIF/Sticker content filter',
    contentFilterHint: 'Controls the content safety level for GIF and sticker search results in this conversation. Higher levels are more restrictive.',
    contentFilterOff: 'Off',
    contentFilterOffTooltip: 'No content filtering. All GIF and sticker results are shown.',
    contentFilterLow: 'Low',
    contentFilterLowTooltip: 'Light filtering. Removes explicit content but allows most results. Suitable for ages 16+.',
    contentFilterMedium: 'Medium',
    contentFilterMediumTooltip: 'Moderate filtering. Removes suggestive and explicit content. Suitable for ages 13+.',
    contentFilterHigh: 'High',
    contentFilterHighTooltip: 'Strictest filtering. Only family-friendly content appears. Suitable for all ages.',
    contentFilterInfoLabel: 'Filter level details',
    conversationHideForMe: 'Hide GIFs for me in this conversation',
    conversationHideForMeHint: 'Only affects your view',
    animateOnHoverOnly: 'Animate GIFs and Stickers only on hover',
    animateOnHoverOnlyHint:
      'Shows a still image until you hover or focus. If no still image is available for a message, the animation plays as usual.',
    animateOnHoverAria: 'GIF or sticker',
    sendNow: 'Send Now',
    sendNowHint: 'When off, the GIF is added as an attachment so you can include a caption or context.',
    klipyHintP1: "We're grateful to Klipy for providing a growing GIF and sticker library to us at no cost to us or you (other than their watermarks). For your privacy, we do not exercise their option to include ads among the GIFs.",
    klipyHintP2: "FYI, any image from a remote website (even Klipy's servers) can be used to track your IP and other info: if preferred, you can turn off GIFs per conversation, or completely via your Adieuu settings.",
    composerButton: 'GIF',
    stickerButton: 'Stickers',
    composerButtonCombined: 'GIFs and Stickers',
} as const;
